import React from 'react';
import { Step } from 'react-joyride';

interface ExtendedStep extends Step {
  action?: string;
}


export const MicrositeJoyrideSteps = {
  WELCOME: 0,
  ADD_BLOCK: 1,
  TOOLBAR: 2,
  CUSTOMIZE_LINK: 3,
  SHARE_CONTENT: 4,
  INSIGHTS_BUTTON: 5,
  INSIGHTS_PAGE: 6,
  FINISH: 7
};


export const PitchJoyrideSteps = {
  WELCOME: 0,
  ADD_BLOCK: 1,
  ADD_STEP: 2,
  CUSTOMIZE_LINK: 3,
  SHARE_CONTENT: 4,
  INSIGHTS_BUTTON: 5,
  INSIGHTS_PAGE: 6,
  FINISH: 7
};

export const getMicrositeEditorSteps = (): Step[] => {
  return [
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Welcome to Microsite Mode!</h2>
          <p className="mt-3">
            Let's take a quick tour to help you get the most out of your Journey Microsite editor.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
      disableBeacon: true
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Add a Block</h2>
          <p className="mt-3">
            Click here to add new content blocks to your microsite such as text, images, videos, or other media.
          </p>
          <p className="mt-2">
            Each block is fully customizable to create engaging single-page experiences.
          </p>
        </div>
      ),
      placement: 'left',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.cc-drag-handle', 
    },
    {
      content: <div><h2 className='font-semibold text-lg'>Toolbar</h2><p className='mt-3'>Use the tools available in this list to add images, links, PDFs or integrations from platforms directly into your Journey</p></div>,
      placement: 'left',
      styles: {
          options: {
              width: 400,
          },
      },
      target: '#journey-toolbar',
  },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Customize Links</h2>
          <p className="mt-3">
            When adding links to your microsite, you can customize how they appear:
          </p>
          <p className="mt-2">
            - As cards with thumbnails<br/>
            - As embedded content<br/>
            - As direct links
          </p>
          <p className="mt-2">
            This helps create a more engaging experience for your visitors.
          </p>
        </div>
      ),
      placement: 'left' ,
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.journey-link-toolbar-option', 
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Share Your Microsite</h2>
          <p className="mt-3">
            Once you're finished creating your microsite, click here to share it with your audience.
          </p>
          <p className="mt-2">
            You can share via a direct link, email, or embed it on your website.
          </p>
        </div>
      ),
      placement: 'left',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.share-journey', 
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Check Your Insights</h2>
          <p className="mt-3">
            Click on this Insights button to view detailed analytics about your microsite's performance.
          </p>
          <p className="mt-2">
            This is where you'll track how users engage with your content.
          </p>
        </div>
      ),
      placement: 'bottom',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.microsite-onboarding-insights', 
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Track Performance with Insights</h2>
          <p className="mt-3">
            The Insights dashboard shows you detailed analytics about your microsite's performance.
          </p>
          <p className="mt-2">
            Monitor visitor engagement, view time spent on content and see which sections are most popular.
          </p>
          <p className="mt-2">
            This data helps you understand your audience and optimize your content for better results.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">You're Ready!</h2>
          <p className="mt-3">
            Now you know the basics of creating engaging microsites with Journey.
          </p>
          <p className="mt-2">
            Try adding different types of content blocks and customizing them to create your perfect microsite.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
    }
  ];
};

export const getPitchEditorSteps = (): ExtendedStep[] => {
  return [
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Welcome to Pitch Mode!</h2>
          <p className="mt-3">
            Let's take a quick tour to help you get the most out of your Journey Pitch editor.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
      disableBeacon: true
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Add Section</h2>
          <p className="mt-3">
            Click here to add slides to your presentation with various types of content.
          </p>
         
        </div>
      ),
      placement: 'bottom',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.pitch-onboarding-add-content', 
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Add Step</h2>
          <p className="mt-3">
            Use this button to add steps to your sections. Steps are individual components that make up your pitch.
          </p>
          <p className="mt-2">
          <p className="mt-2">
            You can add images, videos, documents, and more in a step to create engaging presentations.
          </p>
          </p>
        </div>
      ),
      placement: 'bottom',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.pitch-onboarding-add-step', 
      action: 'onNewStepClicked', // Custom property to trigger onNewStepClicked function
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Upload files & documents</h2>
          <p className="mt-3">
            Add and customize links to external resources and integrations.
          </p>
          <p className="mt-2">
            This will allow you to create content in your presentation
          </p>
        </div>
      ),
      placement: 'right',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.pitch-onboarding-customize-links',
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Share Your Pitch</h2>
          <p className="mt-3">
            Once you've created your perfect pitch, click here to share it.
          </p>
          <p className="mt-2">
            Track how your audience interacts with your content through the insights dashboard.
          </p>
        </div>
      ),
      placement: 'bottom',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.pitch-onboarding-share',
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Check Your Insights</h2>
          <p className="mt-3">
            Click on this Insights button to view detailed analytics about your pitch's performance.
          </p>
          <p className="mt-2">
            This is where you'll monitor how prospects engage with your content.
          </p>
        </div>
      ),
      placement: 'bottom',
      styles: {
        options: {
          width: 350,
        },
      },
      target: '.pitch-onboarding-insights', 
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">Track Performance with Insights</h2>
          <p className="mt-3">
            The Insights dashboard provides powerful analytics on how your audience engages with your pitch.
          </p>
          <p className="mt-2">
            See who viewed your content, how long they spent on each slide and track overall engagement metrics.
          </p>
          <p className="mt-2">
            Use these insights to refine your pitch and follow up with prospects at the right time.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
    },
    {
      content: (
        <div>
          <h2 className="font-semibold text-lg">You're Ready!</h2>
          <p className="mt-3">
            Now you know the basics of creating impactful presentations with Journey.
          </p>
          <p className="mt-2">
            Try adding different types of content and arranging them into a compelling story.
          </p>
        </div>
      ),
      placement: 'center',
      target: 'body',
    }
  ];
}; 